
import Form from '@/components/Forms/Form.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Form,
  },
})
export default class OurVision extends Vue {
}
